import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FADE_IN_OUT_ANIMATION } from './../../animations/animations';

const messagesWithValue = ['max_loading_spaces', 'max', 'min', 'error_equal_value'];

@Component({
    selector: 'gl-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    animations: [FADE_IN_OUT_ANIMATION],
    standalone: false
})
export class TooltipComponent implements AfterViewInit {
  @Input() public side: 'bottom' | 'right' | 'left' | 'top';
  @Input() public message: string;
  @Input() public hookEl: ElementRef<HTMLElement>;
  @Input() public messageValue: number;
  private widthValue: string;
  @HostBinding('@show') public show;
  @HostBinding('class.error') @Input() public isError: boolean;
  @ViewChild('arrow', { static: false, read: ElementRef }) public arrow: ElementRef<HTMLElement>;

  constructor(
    protected renderer: Renderer2,
    protected elRef: ElementRef<HTMLElement>,
    private translate: TranslateService,
  ) {}

  @Input() public set width(value: string) {
    this.widthValue = value;
    this.applyWidth();
  }

  public ngAfterViewInit(): void {
    this.applyWidth();
    setTimeout(() => {
      if (this.messageValue && messagesWithValue.find((message) => message === this.message)) {
        const translatedMaxLoadingSpaces = this.translate.instant(this.message) as string;
        this.message = translatedMaxLoadingSpaces + ' ' + this.messageValue;
      }
    }, 1);
    setTimeout(() => this.calculateArrowPosition(), 1);
  }

  protected calculateArrowPosition() {
    const positionFromLeft =
      this.hookEl.nativeElement.getBoundingClientRect().left -
      this.elRef.nativeElement.getBoundingClientRect().left +
      this.hookEl.nativeElement.offsetWidth / 2 -
      this.arrow.nativeElement.offsetWidth / 2;
    const centerPosition =
      this.elRef.nativeElement.clientHeight / 2 - this.arrow.nativeElement.offsetHeight / 2;

    if (this.side === 'top') {
      this.setStyleArrow('top', this.elRef.nativeElement.clientHeight);
      this.setStyleArrow('left', positionFromLeft);
    } else if (this.side === 'bottom') {
      this.setStyleArrow('bottom', this.elRef.nativeElement.clientHeight);
      this.setStyleArrow('left', positionFromLeft);
    } else if (this.side === 'right') {
      this.setStyleArrow('bottom', centerPosition);
      this.setStyleArrow('right', this.elRef.nativeElement.getBoundingClientRect().width);
    } else if (this.side === 'left') {
      this.setStyleArrow('top', centerPosition);
      this.setStyleArrow('left', this.elRef.nativeElement.getBoundingClientRect().width);
    }
  }

  private applyWidth(): void {
    if (this.widthValue) {
      this.elRef.nativeElement.style.width = this.widthValue;
    }
  }

  private setStyleArrow(position: 'bottom' | 'right' | 'left' | 'top', value: number) {
    this.renderer.setStyle(this.arrow.nativeElement, position, value + 'px');
  }
}
